import global from '../global'

// import AbortController from 'abort-controller';

/* possible rework of this module into a class:
 */
export class API {
}

/**
 *
 * @param {*} obj
 * @param
 */

export var api = obj => {
    if ('user' !== obj.url) {
        localStorage.setItem('lastUserAction', Date.now().toString());
    }
    
    if (obj.method) {
        obj.method = obj.method.toUpperCase()
    } else {
        obj.method = 'GET'
    }

    let _response = {
        success: false,
        status: 0,
        data: null,
        error: null
    }
    return new Promise(resolve => {
        let finalUrl = ''
        if (obj.postman) {
            finalUrl = `${global.api_postman}${obj.url}`
        } else {
            finalUrl = `${global.api}${obj.url}`
        }

        // let content_type = 'application/json';
        // if(obj.formData) {
        //     content_type = 'application/form-data'
        // }

        let headers = {
            method: obj.method,
            headers: {
                Accept: 'application/json'
            }
        }

        if (obj.authorization) {
            headers.headers.Authorization = 'Bearer ' + obj.authorization
        }

        if (obj.params) {
            if (obj.method === 'GET') {
                let queryString = '?'
                let have_param = false
                // for (let prop in obj.params) {
                //     have_param = true;
                //     queryString = `${queryString}${prop}=${obj.params[prop]}&`
                // }

                let b = '?'
                let filter = obj.params
                for (let filterProp in filter) {
                    have_param = true
                    if (filter[filterProp].length === undefined) {
                        for (let prop in filter[filterProp]) {
                            if (prop === 'tags' || prop === 'price') {
                                let tags = filter[filterProp][prop][prop]

                                for (let tag in tags) {
                                    b +=
                                        filterProp +
                                        '[' +
                                        prop +
                                        '][]=' +
                                        filter[filterProp][prop] +
                                        tags[tag] +
                                        '&'
                                }
                                // b += filterProp + '['+prop+'][]=' + filter[filterProp][prop] + '&'
                            } else if (prop === 'created_at') {
                                b += filterProp + '[' + prop + '][]=' + filter[filterProp][prop][0] + '&' + filterProp + '[' + prop + '][]=' + filter[filterProp][prop][1] + '&'
                            } else {
                                b += filterProp + '[' + prop + ']=' + filter[filterProp][prop] + '&'
                            }

                        }
                    } else {
                        if (
                            typeof filter[filterProp] === 'string' ||
                            filter[filterProp] instanceof String
                        ) {
                            b += filterProp + '=' + filter[filterProp] + '&'
                        } else {
                            let index = 0

                            for (let prop of filter[filterProp]) {
                                for (let innerProp in prop) {
                                    b +=
                                        filterProp +
                                        '[' +
                                        index +
                                        '][' +
                                        innerProp +
                                        ']=' +
                                        prop[innerProp] +
                                        '&'
                                }
                                index++
                                // }
                            }

                            for (let prop in filter[filterProp]) {
                                if (Array.isArray(filter[filterProp][prop])) {
                                    for (let innerProp in filter[filterProp][prop]) {
                                        b +=
                                            filterProp +
                                            '[' +
                                            prop +
                                            '][]=' +
                                            filter[filterProp][prop][innerProp] +
                                            '&'
                                        // let tmp = filterProp + "[" + prop + '][]=' + filter[filterProp][prop][innerProp];
                                    }
                                }
                            }

                        }
                    }
                }
                queryString = b
                queryString = queryString.slice(0, -1)
                if (have_param) {
                    finalUrl = `${finalUrl}${queryString}`
                }
            } else if (
                obj.method === 'POST' ||
                obj.method === 'DELETE' ||
                obj.method === 'PATCH' ||
                obj.method === 'PUT'
            ) {
                headers.body = JSON.stringify(obj.params)
            }

            if (!obj.formData) {
                headers.headers['Content-Type'] = 'application/json'
            }
        }

        if (obj.formData) {
            let formData = new FormData()
            if (obj.formDataPut) {
                formData.append('_method', 'put')
            } else if (obj.formDataDoc) {
                for (let name in obj.params) {
                    formData.append(name, obj.params[name])
                }
            } else {
                if (obj.formBanner) {
                } else if (!obj.formDataPostGallery) {
                    formData.append('_method', 'patch')
                }
            }

            if (obj.formDataPostGallery) {
                let i = 0
                for (let name in obj.params.images) {
                    formData.append(`images[${i}]`, obj.params.images[name])
                    i++
                }
            } else {
                if (obj.formBanner && obj.method === 'PATCH') {
                    headers.method = 'POST'
                    formData.append('_method', 'patch')
                }
                for (let name in obj.params) {
                    formData.append(name, obj.params[name])
                }
            }

            headers.body = formData

        }
        fetch(finalUrl, headers)
            .then(response => {
                // handle success

                response.json().then(responseJson => {

                    _response.status = response.status
                    _response.data = responseJson
                    if (response.status === 200) {
                        //_response.data = responseJson.data;

                        _response.success = true
                    } else if (response.status === 401) {
                        localStorage.removeItem('user')
                        localStorage.removeItem('access_token')
                        window.location.href = '/'
                    } else {
                        _response.error = {
                            msg: responseJson.message
                        }
                    }

                    resolve(_response)
                })
            })
            .catch(error => {
                _response.status = error.status
                _response.error = error.error
                resolve(_response)
                // handle error
            })
    })
}



// WEBPACK FOOTER //
// ./src/functions/api.js